import React from "react";
import "../stylesheets/courser.css";
import {
  FaReact,
  FaBootstrap,
  FaNodeJs,
  FaHtml5,
  FaCss3Alt,
} from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import { DiRuby, DiPython } from "react-icons/di";
import { SiRubyonrails } from "react-icons/si";

const Coursel = () => {
  return (
    <div>
      <div className="courosel-parent position-relative" id="courosel">
        <h1 className="position-absolute top-0 start-0 end-0 text-center mt-5">
          Technologes I use
        </h1>
        <div className="gallery">
          <span style={{ "--i": 1 }}>
            <FaReact color="cyan" />
          </span>

          <span style={{ "--i": 2 }}>
            <IoLogoJavascript color="yellow" />
          </span>

          <span style={{ "--i": 3 }}>
            <FaBootstrap color="purple" />
          </span>

          <span style={{ "--i": 4 }}>
            <FaNodeJs color="green" />
          </span>

          <span style={{ "--i": 5 }}>
            <FaHtml5 color="orange" />
          </span>

          <span style={{ "--i": 6 }}>
            <FaCss3Alt color="blue" />
          </span>

          <span style={{ "--i": 7 }}>
            <DiRuby color="red" />
          </span>

          <span style={{ "--i": 8 }}>
            <SiRubyonrails color="red" />
          </span>

          <span style={{ "--i": 9 }}>
            <DiPython color="blue" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Coursel;
